import DataCenter from "pages/DataCenter";
import CarbonFootprintDetail from "pages/DataCenter/CarbonFootprintDetail";
import ProductDetail from "pages/DataCenter/ProductDetail";
import BatteryPassport from "pages/DBPpassport/BatteryPassport";
import LCAemissionreduction from "pages/LcaemissionReduction/LcaemissionReduction";
import React from "react";
import { Route, Switch } from "react-router-dom";
import HomePage from "../HomePage/HomePage";
import CarbonNeutrality from "./../carbonNeutrality"; //碳中和披露
import CarbonNeutralityDisclosure from "./../CarbonNeutralityDisclosure"; // 碳排放披露
import EmissionDetail from "./../emissionDetail/EmissionDetail";
import EmissionReduction from "./../EmissionReduction/EmissionReduction";
import LcaEmissionDetail from "./../LcaemissionReduction/EmissionDetail";
import "./HomePage.scss";

const CommonBox = () => {
  return (
    <div className="home-page">
      <Switch>
        <Route exact path="/home">
          <HomePage />
        </Route>
        <Route exact path="/emissionReduction">
          <EmissionReduction />
        </Route>
        <Route exact path="/emissionDetail">
          <EmissionDetail />
        </Route>
        <Route exact path="/lcaemissionReduction">
          <LCAemissionreduction />
        </Route>
        <Route exact path="/lcaemissionDetail">
          <LcaEmissionDetail />
        </Route>

        <Route exact path="/dataCenter" component={DataCenter}></Route>
        <Route exact path="/productDetail" component={ProductDetail}></Route>
        <Route
          exact
          path="/carbonFootprintDetail"
          component={CarbonFootprintDetail}
        ></Route>
        <Route exact path="/disclosure" component={CarbonNeutralityDisclosure}>
          {/* <CarbonNeutralityDisclosure /> */}
        </Route>
        <Route exact path="/carbonNeutrality" component={CarbonNeutrality}>
          {/* <CarbonNeutrality /> */}
        </Route>
        <Route
          exact
          path="/batteryPassportEn"
          component={BatteryPassport}
        ></Route>
        <Route
          exact
          path="/batteryPassportCh"
          component={BatteryPassport}
        ></Route>
      </Switch>
    </div>
  );
};

export default CommonBox;
